import { 
  FormContainer, 
  Header, 
  LoginContainer, 
  StyledButton, 
  StyledForm, 
  StyledImg, 
  StyledInput
} from './Login.style';

import mealSvg from '../../assets/meal.svg'

import { useNavigate } from 'react-router-dom'

const Login = () => {

  const navigate = useNavigate()
  
  // Login simule edilmesi;
  const userInfo = {
    username: 'umit',
  };


  const handleSubmit = (e)=>{
    e.preventDefault();
    sessionStorage.setItem('user', JSON.stringify(userInfo));
    navigate(-1);
  }

  return (
    <LoginContainer>
      <FormContainer>
        <StyledImg src={mealSvg}/>
        <Header>{'UmitDev Recipe'}</Header>

        <StyledForm onSubmit={handleSubmit}>
          <StyledInput type='text' placeholder='username-dummy' required/>
          <StyledInput type='password' placeholder='password-dummy' required/>
          <StyledButton type='submit'>Login</StyledButton>
        </StyledForm>

      </FormContainer>
    </LoginContainer>
  )
}

export default Login